import {
  Box,
  Button,
  Flex,
  Image,
  MediaBox,
  Typography,
} from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"

import Textarea from "components/landing/textarea"

const CodeBox = styled(Flex).attrs((props) => ({
  alignItems: "center",
  bg: "garnet",
  border: `2px dotted ${props.theme.colors.white}`,
  color: "white",
  fontSize: "16px",
  fontWeight: "600",
  justifyContent: "center",
  letterSpacing: "0.8px",
  mb: "20px",
  mx: "auto",
  px: 2,
  py: "12px",
  width: "fit-content",
  ...props,
}))``

const Footnote = styled(Typography).attrs((props) => ({
  fontSize: "8px",
  fontWeight: "400",
  italic: true,
  mt: 4,
  ...props,
}))`
  b {
    font-weight: 600;
  }
`

const ActiveDeal = ({ activeIndex, element, lazyload }) => {
  const activeDeal = element.data.deals[activeIndex]

  if (!activeDeal) return null

  return (
    <Box textAlign="center" width={{ tablet: "430px" }}>
      {element.textarea && (
        <MediaBox lessThan="desktop">
          <Textarea element={element.textarea} style={element.textarea.style} />
        </MediaBox>
      )}
      {activeDeal.images?.length > 0 ? (
        <Flex justifyContent="center" mb={1}>
          {activeDeal.images.map((image) => (
            <Image
              alt={image.alt}
              fallback={image.fallback}
              key={`${element.anchor_name || element.id}-${
                activeDeal.code || activeDeal.grid_title
              }-${image.alt}`}
              lazyload={lazyload}
              ratio="1 / 1"
              sizes="180px"
              src={image.src}
              width="180px"
            />
          ))}
        </Flex>
      ) : activeDeal.product_image ? (
        <Image
          alt={activeDeal.product_title}
          lazyload={lazyload}
          mb={1}
          ratio="1 / 1"
          sizes="180px"
          srcSet={activeDeal.product_image}
          width="180px"
        />
      ) : null}
      {activeDeal.code && (
        <>
          <Typography
            color="blackPrint"
            fontSize="8px"
            fontWeight="600"
            lineHeight="1"
            mb={1}
          >
            CODE
          </Typography>
          <CodeBox>{activeDeal.code}</CodeBox>
        </>
      )}
      {activeDeal.texts.map((text, i) => {
        if (text.type === "title") {
          return (
            <Typography
              color="blackPrint"
              dangerouslySetInnerHTML={{ __html: text.text }}
              fontSize="16px"
              fontWeight="700"
              key={`${element.anchor_name || element.id}-${
                activeDeal.code || activeDeal.grid_title
              }-title-${i}`}
              mb="12px"
              {...text.style}
            />
          )
        } else if (text.type === "description") {
          return (
            <Typography
              dangerouslySetInnerHTML={{ __html: text.text }}
              fontSize="12px"
              fontWeight="500"
              key={`${element.anchor_name || element.id}-${
                activeDeal.code || activeDeal.grid_title
              }-description-${i}`}
              mb="2px"
              mx="auto"
              width="260px"
              {...text.style}
            />
          )
        } else if (text.type === "instruction") {
          return (
            <Typography
              color="blackPrint"
              dangerouslySetInnerHTML={{
                __html: text.text || `Use code: ${activeDeal.code} in cart.`,
              }}
              fontSize="10px"
              fontWeight="700"
              key={`${element.anchor_name || element.id}-${
                activeDeal.code || activeDeal.grid_title
              }-description-${i}`}
              mb="12px"
              {...text.style}
            />
          )
        } else if (text.type === "cta") {
          return (
            <Button
              as={Link}
              bg="blackPrint"
              color="white"
              fontSize="14px"
              fontWeight="600"
              height="28px"
              key={`${element.anchor_name || element.id}-${
                activeDeal.code || activeDeal.grid_title
              }-cta-${i}`}
              to={activeDeal.product_url || activeDeal.url}
            >
              {text.text || "SHOP NOW"}
            </Button>
          )
        } else if (text.type === "footnote") {
          return (
            <Footnote
              dangerouslySetInnerHTML={{ __html: text.text }}
              key={`${element.anchor_name || element.id}-${
                activeDeal.code || activeDeal.grid_title
              }-footnote-${i}`}
              {...text.style}
            />
          )
        }

        return (
          <Typography
            dangerouslySetInnerHTML={{ __html: text.text }}
            key={`${element.anchor_name || element.id}-${
              activeDeal.code || activeDeal.grid_title
            }-custom-${i}`}
            {...text.style}
          />
        )
      })}
    </Box>
  )
}

ActiveDeal.propTypes = {
  activeIndex: PropTypes.number,
  element: PropTypes.object,
  lazyload: PropTypes.bool,
}

export default ActiveDeal
